import TextField from '@mui/material/TextField';

const FromTextField =  ({
  label = "受注伝票番号",
  helperText = "",
  onChange = (event: any) => { onChange(event); }
}) => (
  <TextField id="tfVoucherNum"
    label={label}
    size="small"
    inputProps={{ maxLength: 10 }}
    onChange={(event: any) => { onChange(event); }}
    error={!!helperText}
    helperText={helperText}
  />
);

export default FromTextField;